<template lang="html">
  <section class="guarantee-section-s1">
    <div class="container oversized-container">
      <div class="row justify-content-center">
        <div class="col-lg-9">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-6 col-info" v-html="body">
              <!-- <h2 class="mb-1 title-2">GARANTIAS</h2>

              <p class="mb-3">
                Cero THC, aceite de cáñamo CBD.<br />
                Cero significa absolutamente ningún nivel detectable de THC. Distribuimos uno de los únicos aceites de cáñamo CBD Wholesale que contiene cero THC y no se diluye ni se recrea con un aislado puro de CBD.
              </p>
              <p class="mb-3">
                Proceso de extracción y purificación.<br />
                Utilizamos la última tecnología de extracción por destilación que permite altos niveles de cannabinoides, especialmente CBD, CBG, CBC y CBN, al tiempo que elimina cantidades no deseadas de THC, clorofila, lípidos y ácidos grasos.
              </p>
              <p>
                Pruebas rigurosas<br />
                Las pruebas de cromatografía y HPLC in situ garantizan niveles precisos de cannabinoides y confirman que los niveles de THC son> .3% o que el THC se ha eliminado por completo a través de nuestros procesos patentados.
              </p> -->
            </div>

            <div class="col-md-9 col-lg-6 col-xl-5 offset-xl-1 col-image">
              <div class="image" v-bind:style="{ backgroundImage: 'url('+imageUrl+')' }">
                <img src="public/images/shared/empty.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data(){
    return{
      body: null,
      imageUrl: null,
     
    }
  },
  methods: {
    getBlogs: function(){
      axios.get(tools.url('/api/guarantee')).then((response)=>{
          this.body = response.data.body;
          this.imageUrl = response.data.imageUrl;
      });
    }
  },

  mounted(){
   
    this.getBlogs();
  }
}
</script>
